// removed by extract-text-webpack-plugin
module.exports = {"StartingModalMessage":"StartingModalMessage__-loca-__1fEuC","About":"StartingModalMessage__-loca-__2qCh3","EmailListSection":"StartingModalMessage__-loca-__1mnU5","TextLine":"StartingModalMessage__-loca-__136tO","EmailListLink":"StartingModalMessage__-loca-__93QNz","HowItWorks":"StartingModalMessage__-loca-__kN5jU","Open":"StartingModalMessage__-loca-__1buAb","Close":"StartingModalMessage__-loca-__219Ch","SideDrawerCloseButton":"StartingModalMessage__-loca-__2l0Gc","BestWishes":"StartingModalMessage__-loca-__pE4NJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Modal/StartingModalMessage/StartingModalMessage.css
// module id = 224
// module chunks = 0